"use client";

/**
 * One of our maps (`OurMapFrame`), fetched with its stylesheet only where a map is drawn:
 * the live trail sheet is in the shell, so a plain import would put MapLibre's CSS on every
 * page. MapLibre itself comes later still, through `loadMapLibre`.
 */
import dynamic from "next/dynamic";
import type { OurMapProps } from "@/components/ui/OurMapFrame";

export const OurMap = dynamic<OurMapProps>(() => import("@/components/ui/OurMapFrame"), { ssr: false });
